export default "#### CARMA COLLECT\n\nUNIT 5/ 1-3 BURROWS RD, ST PETERS NSW 2044 AUSTRALIA\n";